<template>
    <div>
        <div class="button-area">
            <Button @click="save()" :loading="saveLoading" type="primary" class="button-right-left">保存</Button>
            <Button @click="back()" class="button-right">返回</Button>
        </div>
        <div class="form-area">
            <Form style="width: 1100px" :model="model" ref="form" :label-width="110" label-position="left" inline
                  :rules="rules">
                <FormItem :class="{'model-hidden': true}" label="文本框">
                    <Input v-model="model.id" type="text"></Input>
                </FormItem>
                <FormItem :class="{'model-hidden': true}" label="文本框">
                    <Input v-model="model.userId" type="text"></Input>
                </FormItem>
                <FormItem label="姓名" prop="name">
                    <Input v-model="model.name" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="手机号" prop="phone">
                    <Input v-model="model.phone" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="职位" prop="post">
                    <Input v-model="model.post" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="单位" prop="unit">
                    <Input v-model="model.unit" style="width:320px" type="text"></Input>
                </FormItem>
                <!-- <FormItem label="部门" prop="orginName">
                    <Input v-model="model.orginName" style="width:320px" type="text"></Input>
                </FormItem> -->
                <!-- <FormItem label="服务专家类型" prop="type">
                    <Input v-model="model.type" style="width:320px" type="text"></Input>
                </FormItem> -->
                <FormItem label="服务内容" prop="serviceContent">
                    <Input v-model="model.serviceContent" style="width:320px" type="text"></Input>
                </FormItem>
                <FormItem label="固定电话" >
                    <Input v-model="model.mobile" style="width:320px" type="text"></Input>
                </FormItem>
                <br>
                <FormItem label="照片" prop="pic">
                    <upload
                            accept="image/*"
                            :action=uploadUrl
                            :headers="headers"
                            :limit="1"
                            list-type="picture-card"
                            :file-list="fileList"
                            :before-upload="beforeAvatarUpload"
                            :on-success="handleSuccess"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                    </upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </FormItem>
                <br />
                <FormItem label="专家简介" prop="spec" style="width:100%;margin-right:0;">
                    <Input :rows="5" v-model="model.spec" type="textarea"></Input>
                </FormItem>
            </Form>
        </div>
    </div>
</template>

<script>
    import util from '@/libs/util.js'
    import upload from '@/components/upload'

    export default {
        name: 'tqtExpertForm',
        components: {upload},
        data () {
            return {
                //ID
                id: null,
                saveLoading: false,
                //表单参数
                model: {
                    id: null,
                    userId: null,
                    post: null,
                    orginName: '',
                    spec: null,
                    type: null,
                    serviceContent: null,
                    mobile: null,
                    pic: null,
                    phone: null,
                    unit: null,
                    name: null,
                },
                uploadUrl: util.baseUrl + 'api/common/upload',
                headers: { 'Authorization': localStorage.token },
                dialogImageUrl: '',
                dialogVisible: false,
                fileList: [],
                rules: {
                    name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
                    post: [{ required: true, message: '请输入职位', trigger: 'blur' }],
                    phone: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {pattern: /^[1][0-9]{10}$/, message: '请输入正确的手机号'},
                    ],
                    spec: [{ required: true, message: '请输入专家简介', trigger: 'blur' }],
                    serviceContent: [{ required: true, message: '请输入服务内容', trigger: 'blur' }],
                    pic: [{ required: true, message: '请上传照片', trigger: 'change' }],
                    // type: [{ required: true, message: '请上传专家类型（type数字）', trigger: 'blur' },
                    //       {pattern: /^[][0-9]{10}$/, message: '请输入正确数字'}],
                    // orginName: [{ required: true, message: '请上传部门名称', trigger: 'blur' }],
                    // mobile: [{ required: true, message: '请上传部门名称', trigger: 'input' }],
                },
            }
        },
        mounted () {
            if (typeof (this.$route.query.id) !== 'undefined' && this.$route.query.id !== null && this.$route.query.id !== '') {
                this.id = this.$route.query.id
                //ID存在渲染表单
                this.initForm()

            }
        },
        methods: {
            //保存
            save () {
                this.$refs['form'].validate((valid) => {
                    if (!valid) return
                    if (this.id) {
                        this.update()
                    } else {
                        this.create()
                    }
                })

            },

            create () {
                let _this = this
                _this.saveLoading = true
                _this.model.orginName = _this.model.unit
                util.http.post('/api/tqtExperts', this.model, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {
                    _this.$Notice.success({
                        title: '保存成功!'
                    })
                    _this.back()
                }).catch(function (error) {
                    if (error?.response?.status != 400) {
                        _this.$Notice.error({
                        title: "保存失败!",
                        });
                    }
                    _this.saveLoading = false
                })
            },

            update () {
                let _this = this
                _this.saveLoading = true
                _this.model.orginName = _this.model.unit
                util.http.put('/api/tqtExperts', this.model, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {
                    _this.$Notice.success({
                        title: '更新成功!'
                    })
                    _this.back()
                }).catch(function (error) {
                    if (error?.response?.status != 400) {
                        _this.$Notice.error({
                        title: "更新失败!",
                        });
                    }
                    _this.saveLoading = false
                })
            },

            //渲染表单
            initForm () {
                let _this = this
                util.http.get('/api/tqtExperts/' + this.id, {
                    params: {}
                }).then(function (response) {
                    let tem = response.data
                    _this.model.id = tem.id
                    _this.model.userId = tem.userId
                    _this.model.post = tem.post
                    _this.model.orginName = tem.unit
                    _this.model.spec = tem.spec
                    _this.model.type = tem.type
                    _this.model.serviceContent = tem.serviceContent
                    _this.model.mobile = tem.mobile
                    _this.model.pic = tem.pic
                    _this.model.phone = tem.phone
                    _this.model.unit = tem.unit
                    _this.model.name = tem.name
                    _this.fileList = tem.pic ? [{
                        url:tem.imagePath.pic.url || '',
                    }] : []

                }).catch(function (error) {
                    _this.$Notice.error({
                        title: '获取表单失败!'
                    })
                    console.log(error)
                })
            },

            //返回,需要自定义配置路由
            back () {
                let _this = this
                let tagName = _this.$route.name
                _this.$store.commit('removeTag', tagName)
                _this.$store.commit('closePage', tagName)
                _this.$router.push({
                    name: 'tqt_expert'
                })
            },
            handleSuccess (response, file, fileList) {
                if (response.success) {
                    this.model.pic = response.result.path || ''
                    this.fileList = fileList
                    console.log(this.fileList, 'this.fileList')
                }
            },
            handleRemove (file, fileList) {
                this.model.pic = ''
                console.log(file, fileList)
            },
            handlePictureCardPreview (file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            },
            beforeAvatarUpload (file) {
                if(!(file.type||'').startsWith('image/')){
                    this.$message.warning('只能上传图片格式的文件')
                    return;
                }
                const isLt2M = file.size / 1024 / 1024 < 2
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!')
                }
                return  isLt2M
            }

        }
    }
</script>

<style scoped>
    .button-area {
        display: flex;
        justify-content: flex-end;
    }

    .button-right-left {
        margin-right: 15px;
    }

    .button-right {
        margin-right: 55px;
    }

    .form-area {
        margin-top: 40px;
        display: flex;
        justify-content: center;
    }

    .form-flex {
        display: flex;
        justify-content: space-between;
    }

    .model-hidden {
        display: none;
    }
    .ivu-form-item{
        margin-right:60px
    }
</style>
